module.exports = __webpack_public_path__ + "static/media/nav-services.1298ec2c.png";